import _ from 'lodash';
import Logger from '../util/Logger';
import User from './User';

/**
 * Methods for consistent access to Tenant Hero properties via server returned JSON.
 *
 *
 *
 * All interactions or accesses on User fields should be handled via helper method in this
 * class. Methods should only be to avoid `this` scoping issues in nested calls.
 *
 * Utility methods should throw in the case of unexpected constant mismatch such as missing data,
 * all calls to these methods should be guarded at the callsite.
 *
 * Tenant Hero objects are returned from GET /admin/tenants/{id}/heroes
 *
 * { id, name, email,
 *      stats: {
 *        popins, reach, last_popin}
 *      }
 * }
 *
 *
 */
export default {

  /**
   * Extracts the id field from a given tenant json
   *
   * @param {object} hero hero json
   * @returns {string} name of the tenant hero
   */
  getId (hero) {
    return User.getId(hero);
  },

  getName (hero) {
    return User.getDisplayName(hero);
  },

  getEmail (hero) {
    return User.getEmail(hero);
  },

  getInitials (hero) {
    return User.getInitials(hero);
  },

  getMediaAvatarPhoto (hero) {
    return User.getMediaAvatarPhoto(hero);
  },

  getPopins (hero) {
    if (!hero) {
      Logger.assert('Cannot call getPopins() without a hero object');
    } else {
      return _.get(hero, 'stats.popins', 0);
    }
  },
  getReach (hero) {
    if (!hero) {
      Logger.assert('Cannot call getReach() without a hero object');
    } else {
      return _.get(hero, 'stats.reach', 0);
    }
  },
  getLastPopin (hero) {
    if (!hero) {
      Logger.assert('Cannot call getLastPopin() without a hero object');
    } else {
      const time = _.get(hero, 'stats.last_popin');
      if (time === undefined || time === null) {
        Logger.error('Missing last_popin time ', this.getId(hero));
        return null;
      } else {
        return time;
      }
    }
  }
};
